import { useEffect } from "react";

/**
 * Move keyboard focus once when a view mounts (e.g. full-page export flows).
 *
 * @param {React.RefObject<HTMLElement | null>} targetRef
 * @param {boolean} [enabled]
 */
export function useFocusOnMount(targetRef, enabled = true) {
  useEffect(() => {
    if (!enabled) return;
    targetRef.current?.focus();
  }, [enabled, targetRef]);
}
